<span class="auth-buttons">
  @if (userLoggedIn() === false) {
    <form class="form-inline">
      <li class="nav-item nav-item-sm-block auth-button">
        <a href="/Account/Register?returnUrl={{currentUrl()}}&clientCode={{registrationCode()}}" id="register-btn" class="btn btn-outline-light btn-sm-block text-center ml-0 mr-md-2 avi-sm-btn">Register</a>
      </li>
      <li class="nav-item nav-item-sm-block auth-button">
        <a href="/Account/Login?returnUrl={{currentUrl()}}" id="login-btn" class="btn btn-outline-light btn-sm-block text-center ml-0 ml-md-2 avi-sm-btn">Log in</a>
      </li>
    </form>
  } @else {
    <li class="nav-item nav-item-sm-block auth-button ml-2">
      <button type="submit" id="logout-btn" class="btn btn-outline-light btn-sm-block text-center my-2" (click)="logout()">Log out</button>
    </li>
  }
</span>
